<template>
  <div class="flex stock-board justify-center" v-loading="loading">

    <div class="card-box flex justify-between">

      <div class="flex card-box-line" style="margin-bottom: 6px;">
        <div class="stock-card flex align-center">
          <div class="stock-card-icon bgRed flex align-center justify-center">
            <i class="iconfont iconweifukuanjine colorRed"></i>
          </div>
          <div style="padding-left: 12px;">
            <div class="size14 color666" style="line-height: 20px;">
              未付款金额{{ sumMoney.currencySymbol | defaultShow('(',')','') }}
            </div>
            <div class="size22" style="font-weight: bold;line-height: 30px;">
              {{ amountSymbol(sumMoney.unpaidMoney).origin | defaultShow}}
            </div>
          </div>
        </div>
      </div>

      <div class="flex card-box-line" style="margin-top: 6px;">
        <div class="stock-card flex align-center">
          <div class="stock-card-icon bgBlue flex align-center justify-center">
            <i class="iconfont iconzongjijine colorBlue"></i>
          </div>
          <div style="padding-left: 12px;">
            <div class="size14 color666" style="line-height: 20px;">
              总金额{{ sumMoney.currencySymbol | defaultShow('(',')','') }}
            </div>
            <div class="size22" style="font-weight: bold;line-height: 30px;">
              {{ amountSymbol(sumMoney.sumMoney).origin | defaultShow}}
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="card-box flex justify-between" style="margin-left: 16px;">

      <div class="flex card-box-line" style="margin-bottom: 6px;">
        <div class="stock-card flex align-center">
          <div class="stock-card-icon bgGreen flex align-center justify-center">
            <i class="iconfont iconfukuanjine colorGreen"></i>
          </div>
          <div style="padding-left: 12px;">
            <div class="size14 color666" style="line-height: 20px;">
              已付款金额{{ sumMoney.currencySymbol | defaultShow('(',')','') }}
            </div>
            <div class="size22" style="font-weight: bold;line-height: 30px;">
              {{ amountSymbol(sumMoney.paidMoney).origin | defaultShow}}
            </div>
          </div>
        </div>
      </div>

      <div class="flex card-box-line" style="margin-top: 6px;">
        <div class="stock-card flex align-center">
          <div class="stock-card-icon bgPurple flex align-center justify-center">
            <i class="iconfont iconshibai colorPurple"></i>
          </div>
          <div style="padding-left: 12px;">
            <div class="size14 color666" style="line-height: 20px;">
              转账失败金额{{ sumMoney.currencySymbol | defaultShow('(',')','') }}
            </div>
            <div class="size22" style="font-weight: bold;line-height: 30px;">
              {{ amountSymbol(sumMoney.transferFailed).origin | defaultShow}}
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {amountSymbol} from "@/filters";
import {getRemittanceRecordSumMoney} from "@/api/finance";
import {dashboardMixin, queryMixin} from "@/minxins";
import {mapGetters} from "vuex";
import {isMeaningful, isMeaningless} from "@/utils/common";

export default {
  name: "settlement-board",
  mixins: [queryMixin, dashboardMixin],
  data() {
    return {
      sumMoney: {},
      loading: false
    }
  },
  computed:{
    filter() {
      return {
        dateTime: this.timezoneText,
        currency: this.dashboardCurrency,
      }
    }
  },
  methods: {
    amountSymbol,
    $gjQuery() {
      if(!this.showStoreMask){
        return
      }
      // 缓存了时区时，第一次不请求
      if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
        return
      }
      this.loading = true
      getRemittanceRecordSumMoney({currency: this.dashboardCurrency})
          .then((data) => {
            this.sumMoney = data;
          }).complete(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.iconfont {
  font-size: 26px;
}

.stock-board {
  height: 252px;

  .card-box {
    width: 42.255%;
    min-width: 360px;
    flex-direction: column;

    .card-box-line {
      flex: 1;
      border: 1px solid #EEEFF0;
      border-radius: 2px;

    }
  }
}

.stock-card {
  box-sizing: border-box;
  width: 50%;
  flex: none;
  padding-left: 24px;

  .stock-card-icon {
    width: 56px;
    height: 56px;
    border-radius: 8px;
  }

}
</style>